var map = {
	"./1.png": "f8b7",
	"./2.png": "7aaa",
	"./3.png": "843c",
	"./4.png": "3a00",
	"./5.png": "5395",
	"./bgc.png": "0383",
	"./矩形 687@2x.png": "fe4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2992";